<div class="modal fade" id="moreoptions" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-container">
                <div class="modal-header">
                    <h5>{{ 'NETWORK_ASSET.MORE.ASSET_TYPE.' + assetType | translate }}</h5>
                    <button class="close-btn" data-bs-dismiss="modal" aria-label="Close">&times;</button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-4" *ngFor="let itemSet of data">
                            <div class="card" [ngStyle]="{ 'border-color': borderColor }"
                                [ngClass]="{ 'show-more-selected': selectedIds.includes(itemSet.id)}"
                                (click)="selectId(itemSet.id)">
                                <h6 class="title" [ngStyle]="{ color: borderColor }">
                                    {{ itemSet.name }}
                                </h6>
                                <div class="item" *ngFor="let item of itemSet.counts">
                                    <span>{{ 'NETWORK_ASSET.MORE.' + item.name | translate }}</span>
                                    <span class="value">{{ item.count | number }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <app-paging *ngIf="count > 0" tabindex="-1" [pageSize]="pageSize" [useDirect]="true" [count]="count"
                        [currentPage]="page" (pageChange)="pageChange($event)">
                    </app-paging>

                    <button tabindex="-1" class="btn btn-success" [disabled]="selectedIds.length == 0"
                        (click)="applyChanges()" #closemoreoptions data-bs-dismiss="modal" aria-label="Close">
                        {{ 'NETWORK_ASSET.MORE.APPLY' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>